import { render, staticRenderFns } from "./IssuedDocumentList.vue?vue&type=template&id=3b198552&"
import script from "./IssuedDocumentList.vue?vue&type=script&lang=js&"
export * from "./IssuedDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports